import { Injectable } from '@angular/core';

import { NgRedux } from '@angular-redux/store';

import { MatrixProductPrice, Product, RidangoReduxAction } from '@ridango/core';

import { Observable } from 'rxjs';

import { ProductActions } from './products.actions';
import { ProductsPartialStoreState } from './products.reducer';
import * as ProductSelectors from './products.selectors';

@Injectable()
export class ProductsFacade {
    allIds$: Observable<string[]> = this.store.select(ProductSelectors.getAllIds);
    all$: Observable<Product[]> = this.store.select(ProductSelectors.getAll);
    loading$: Observable<boolean> = this.store.select(ProductSelectors.getLoading);
    selected$: Observable<Product> = this.store.select(ProductSelectors.getSelected);
    products$: Observable<Product[]> = this.store.select(ProductSelectors.getAllProducts);
    fixedSumProducts$: Observable<Product[]> = this.store.select(ProductSelectors.getFixedSumProducts);
    variableSumProduct$: Observable<Product> = this.store.select(ProductSelectors.getVariableSumProduct);
    filteredProducts$: Observable<Product[]> = this.store.select(ProductSelectors.getFilteredProducts);
    matrixProductPrices$: Observable<MatrixProductPrice[]> = this.store.select(ProductSelectors.getMatrixProductPrices);

    constructor(
        private store: NgRedux<ProductsPartialStoreState>,
        private actions: ProductActions
    ) {}

    dispatch(action: RidangoReduxAction) {
        this.store.dispatch(action);
    }

    fetchWalletProducts(channel = 'web') {
        const payload = {
            channel: channel,
            isWalletType: true
        };

        this.dispatch(this.actions.fetchProducts(payload));
    }

    fetchPurchaseProducts(channel = 'web') {
        const payload = {
            channel: channel,
            isWalletType: false
        };
        this.dispatch(this.actions.fetchProducts(payload));
    }

    /**
     * @param {Product} product
     */
    setSelectedProduct(product: Product) {
        this.dispatch(this.actions.setSelectedProductId(product.product_id));
        this.dispatch(this.actions.setSelectedProduct(product));
    }

    setFilteredProducts(products: Product[]) {
        this.dispatch(this.actions.setFilteredProducts(products));
    }

    setPrices(normalizedPrices: any) {
        this.dispatch(this.actions.setMatrixProductPrices(normalizedPrices));
    }
}
